var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenReassign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "style=linear"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.44295 1.97228C9.47249 1.97228 10.3107 2.81052 10.3107 3.84005C10.3107 4.86962 9.47249 5.70585 8.44295 5.70585C7.41342 5.70585 6.57519 4.86962 6.57519 3.84005C6.57519 2.81052 7.41342 1.97228 8.44295 1.97228ZM8.44295 0C6.32669 0 4.60291 1.72186 4.60291 3.84005C4.60291 5.95633 6.32669 7.67814 8.44295 7.67814C10.5592 7.67814 12.283 5.95633 12.283 3.84005C12.283 1.72186 10.5592 0 8.44295 0Z",
    fill: "#008556"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1.73287 23.9999C1.16122 23.9999 0.748704 23.4256 0.74673 22.8832L0.719116 16.3056C0.719116 12.3729 4.18443 9.17578 8.44261 9.17578C11.5628 9.17578 14.4364 10.9903 15.5961 13.6884C15.8111 14.1894 15.5803 14.7692 15.0794 14.9842C14.5843 15.1952 14.0005 14.9684 13.7816 14.4655C12.9315 12.4814 10.7857 11.1481 8.44261 11.1481C5.27314 11.1481 2.69141 13.4596 2.69141 16.3017L2.71902 22.8753C2.72099 23.4197 2.28083 23.9999 1.73682 23.9999H1.73287Z",
    fill: "#008556"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.7387 20.52H8.37543C7.83107 20.52 7.38928 20.1979 7.38928 19.6535C7.38928 19.1092 7.83107 18.5312 8.37543 18.5312H16.8563C17.4006 18.5312 17.8424 19.1092 17.8424 19.6535C17.8424 20.1979 17.4006 20.52 16.7387 20.52Z",
    fill: "#008556"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M10.3833 23.4111L7.48005 20.3324C7.11912 19.9537 7.11912 19.36 7.48005 18.9814L10.3833 15.9026C10.754 15.5062 11.3793 15.4845 11.7757 15.8632C12.1721 16.2359 12.1899 16.8592 11.8151 17.2556L9.55292 19.6559L11.8151 22.0581C12.1899 22.4526 12.1605 23.0658 11.7757 23.4506C11.2654 23.9609 10.5746 23.6163 10.3833 23.4111Z",
    fill: "#008556"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenReassign);
export default __webpack_public_path__ + "static/media/greenReassign.594b383993117529fbaa66e8264fa941.svg";
export { ForwardRef as ReactComponent };